import {useMemo} from 'react'
import mergeDeep from '../../../../common/helpers/merge-deep'
import INIT_VALUES from '../constants/init-values'
import IDS from '../constants/ids'
import moment from 'moment'
import GlobalOptionsInterface from '../types/global-options'
import {russia} from '../../../../common/components/custom-form-components/international-phone'

export default function useInitialValues(
    initialValues: GlobalOptionsInterface['initialValues'] = {}
) {
    return useMemo(() => {
        const values = mergeDeep({}, initialValues, INIT_VALUES)
        if (initialValues.insurant) {
            const {insurant, promocode} = initialValues
            if (insurant.birthday) values[IDS.INSURANT][IDS.BIRTHDAY] = moment(insurant.birthday)
            if (insurant.passportDateOfIssue)
                values[IDS.INSURANT]['passportDateOfIssue'] = moment(insurant.passportDateOfIssue)
            if (insurant.phone)
                values[IDS.INSURANT]['phone'] = {
                    phone: insurant.phone,
                    country: russia,
                }
            if (promocode) values[IDS.PROMOCODE] = promocode
        }
        return values
    }, [])
}
